export interface CatalogEntry {
  name: string;
  label: string;
  iconifyId: string;
}

// Brand hex colors for simple-icons:* entries (which use currentColor).
// logos:* icons have colors baked into their SVG paths — no entry needed.
export const SIMPLE_ICON_COLORS: Record<string, string> = {
  "simple-icons:clickhouse":  "#F5C500",
  "simple-icons:natsdotio":   "#27AAE1",
  "simple-icons:timescale":   "#FDB515",
};

export function getBrandColor(iconifyId: string): string | undefined {
  return SIMPLE_ICON_COLORS[iconifyId];
}

export const ICON_CATALOG: CatalogEntry[] = [
  // Cloud providers
  { name: "aws",            label: "AWS",             iconifyId: "logos:aws" },
  { name: "aws-s3",         label: "S3",              iconifyId: "logos:aws-s3" },
  { name: "aws-ec2",        label: "EC2",             iconifyId: "logos:aws-ec2" },
  { name: "aws-lambda",     label: "Lambda",          iconifyId: "logos:aws-lambda" },
  { name: "aws-rds",        label: "RDS",             iconifyId: "logos:aws-rds" },
  { name: "aws-dynamodb",   label: "DynamoDB",        iconifyId: "logos:aws-dynamodb" },
  { name: "aws-sqs",        label: "SQS",             iconifyId: "logos:aws-sqs" },
  { name: "aws-sns",        label: "SNS",             iconifyId: "logos:aws-sns" },
  { name: "aws-kinesis",    label: "Kinesis",         iconifyId: "logos:aws-kinesis" },
  { name: "aws-cloudfront", label: "CloudFront",      iconifyId: "logos:aws-cloudfront" },
  { name: "gcp",            label: "Google Cloud",    iconifyId: "logos:google-cloud" },
  { name: "azure",          label: "Azure",           iconifyId: "logos:microsoft-azure" },
  // Databases
  { name: "clickhouse",     label: "ClickHouse",      iconifyId: "simple-icons:clickhouse" },
  { name: "postgresql",     label: "PostgreSQL",      iconifyId: "logos:postgresql" },
  { name: "mysql",          label: "MySQL",           iconifyId: "logos:mysql" },
  { name: "mongodb",        label: "MongoDB",         iconifyId: "logos:mongodb" },
  { name: "redis",          label: "Redis",           iconifyId: "logos:redis" },
  { name: "elasticsearch",  label: "Elasticsearch",   iconifyId: "logos:elasticsearch" },
  { name: "cassandra",      label: "Cassandra",       iconifyId: "logos:cassandradb" },
  { name: "sqlite",         label: "SQLite",          iconifyId: "logos:sqlite" },
  { name: "cockroachdb",    label: "CockroachDB",     iconifyId: "logos:cockroachdb" },
  { name: "neo4j",          label: "Neo4j",           iconifyId: "logos:neo4j" },
  { name: "influxdb",       label: "InfluxDB",        iconifyId: "logos:influxdb" },
  // Messaging / Streaming
  { name: "kafka",          label: "Kafka",           iconifyId: "logos:apache-kafka" },
  { name: "rabbitmq",       label: "RabbitMQ",        iconifyId: "logos:rabbitmq" },
  { name: "nats",           label: "NATS",            iconifyId: "simple-icons:natsdotio" },
  { name: "pulsar",         label: "Pulsar",          iconifyId: "logos:apache-pulsar" },
  // Infra / Platform
  { name: "nginx",          label: "Nginx",           iconifyId: "logos:nginx" },
  { name: "traefik",        label: "Traefik",         iconifyId: "logos:traefik" },
  { name: "istio",          label: "Istio",           iconifyId: "logos:istio" },
  { name: "terraform",      label: "Terraform",       iconifyId: "logos:terraform-icon" },
  { name: "ansible",        label: "Ansible",         iconifyId: "logos:ansible" },
  { name: "helm",           label: "Helm",            iconifyId: "logos:helm" },
  { name: "prometheus",     label: "Prometheus",      iconifyId: "logos:prometheus" },
  { name: "grafana",        label: "Grafana",         iconifyId: "logos:grafana" },
  { name: "kibana",         label: "Kibana",          iconifyId: "logos:kibana" },
  { name: "opentelemetry",  label: "OpenTelemetry",   iconifyId: "logos:opentelemetry" },
  { name: "vault",          label: "Vault",           iconifyId: "logos:vault" },
  { name: "consul",         label: "Consul",          iconifyId: "logos:consul" },
  // Languages / Runtimes
  { name: "go",             label: "Go",              iconifyId: "logos:go" },
  { name: "python",         label: "Python",          iconifyId: "logos:python" },
  { name: "nodejs",         label: "Node.js",         iconifyId: "logos:nodejs" },
  { name: "typescript",     label: "TypeScript",      iconifyId: "logos:typescript-icon" },
  { name: "rust",           label: "Rust",            iconifyId: "logos:rust" },
  { name: "java",           label: "Java",            iconifyId: "logos:java" },
  { name: "graphql",        label: "GraphQL",         iconifyId: "logos:graphql" },
  // Platforms
  { name: "docker",         label: "Docker",          iconifyId: "logos:docker-icon" },
  { name: "kubernetes",     label: "Kubernetes",      iconifyId: "logos:kubernetes" },
  { name: "linux",          label: "Linux",           iconifyId: "logos:linux-tux" },
  { name: "github",         label: "GitHub",          iconifyId: "logos:github-icon" },
  { name: "gitlab",         label: "GitLab",          iconifyId: "logos:gitlab" },
];
